import React from "react";
import {useFormik} from "formik";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import * as yup from "yup";
import {Form, Modal, Alert, Input, message, Select} from "antd";
import {useTranslation} from "react-i18next";

export const CourierZoneManuallyUpdateModal = ({
    courierId,
    visibility,
    onClose = async () => {},
    onComplete = async () => {}
}) => {
    const stores = useStore();
    const {t} = useTranslation();

    const [loading, courierData] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getCourier.bind(null, {
            courierId
        }),
        condition: visibility && courierId,
        initialCall: false,
        dependencies: [visibility, courierId]
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            zoneId: ""
        },
        validationSchema: yup.object().shape({
            zoneId: yup
                .string()
                .nullable()
                .required(t("validation.required", {ns: "common"}))
        }),
        onSubmit: async values => {
            await handleSaveCourier({values});
        }
    });

    const handleSaveCourier = async ({values}) => {
        try {
            const success = await stores.operationOrganizationStore.assignZoneToCourier({
                courierId,
                zoneId: values.zoneId
            });
            if (success) {
                onComplete();
                onClose();
                return;
            } else {
                throw new Error("Bölge kuryeye atanırken hata oluştu");
            }
        } catch (error) {
            message.error(error.message || "Bölge kuryeye atanırken hata oluştu");
        }
    };

    return (
        <Form layout="vertical">
            <Modal
                title="Bölge Seçimi"
                visible={visibility}
                onCancel={onClose}
                onOk={formik.handleSubmit}
                okText={t("modal.saveButton", {ns: "common"})}
                cancelText={t("modal.cancelButton2", {ns: "common"})}
                confirmLoading={formik.isSubmitting}
                okButtonProps={{
                    disabled: formik.isSubmitting || loading
                }}
                cancelButtonProps={{
                    disabled: formik.isSubmitting || loading
                }}
                bodyStyle={{
                    display: "flex",
                    flexDirection: "column",

                    gap: "8px 8px"
                }}
            >
                <Alert
                    message="Kuryenin çalışacağı tek bir bölge seçimi yapmalısınız. Diğer bölgeler kurye üzerinden silinecektir."
                    type="info"
                />
                <Form.Item
                    key={"Bölge Seçimi"}
                    label={"Bölge Seçimi"}
                    name="zoneId"
                    validateStatus={
                        formik.errors.zoneId && formik.touched.zoneId ? "error" : "success"
                    }
                    help={
                        formik.errors.zoneId && formik.touched.zoneId ? formik.errors.zoneId : null
                    }
                    disabled={formik.isSubmitting || loading}
                    style={{
                        marginBottom: 0
                    }}
                >
                    <Select
                        showSearch
                        value={formik.values.zoneId}
                        data-testid="zoneSelect"
                        onChange={value => formik.setFieldValue("zoneId", value)}
                    >
                        {courierData?.data?.zoneInfo?.map(item => (
                            <Select.Option key={item.zoneId} value={item.zoneId}>
                                {item.zoneName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Modal>
        </Form>
    );
};
